
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftLeft75 as ObiThreewayAcuatorGenericInleftLeft75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-left-75.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftLeft75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-left-75',
   elementClass: ObiThreewayAcuatorGenericInleftLeft75Element,
   events: {
     
   }
  });
 
 